// frontend-web/src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { initDeviceId } from "./utils/deviceId"; // 🔥 NEW
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import ManagementDashboard from "./pages/ManagementDashboard";
import UserDashboard from "./pages/UserDashboard";
// YE 3 PAGES IMPORT KARO
import Subjects from "./pages/Admin/Subjects";
import Questions from "./pages/Admin/Questions";
import UploadCSV from "./pages/Admin/UploadCSV";
import AdminStudyContent from "./pages/AdminStudyContent";
import AdminPracticeSet from "./pages/AdminPracticeSet";
import AdminScholarshipExam from "./pages/AdminScholarshipExam";
import Subscription from "./pages/Subscription";
import { getCurrentUser } from "./api";
import StudentPracticeList from "./pages/Student/StudentPracticeList";
import StudentTakePractice from "./pages/Student/StudentTakePractice";
import PracticeSetList from "./pages/Admin/PracticeSetList";
import ViewQuestions from "./pages/Admin/ViewQuestions";
import EditQuestion from "./pages/Admin/EditQuestion";
import ViewCaseStudy from "./pages/Admin/ViewCaseStudy";
import EditCaseStudy from "./pages/Admin/EditCaseStudy";
import MySubscription from "./pages/MySubscription";
import StudyContentList from './pages/Admin/StudyContentList';
import StudyContentEdit from "./pages/Admin/StudyContentEdit";
import ViewPracticeSet from "./pages/Admin/ViewPracticeSet";
import EditPracticeSet from "./pages/Admin/EditPracticeSet";
import UserPracticeList from "./pages/Student/PracticeList";
import QuizPage from "./pages/Student/QuizPage";
import CreateMegaScholarship from "./pages/Admin/CreateMegaScholarship";
import MegaScholarshipList from "./pages/Admin/MegaScholarshipList";
import AddQuestionsToMegaExam from "./pages/Admin/AddQuestionsToMegaExam";
import ViewMegaScholarship from "./pages/Admin/ViewMegaScholarship";
import AdminMegaQuizPreview from "./pages/Admin/AdminMegaQuizPreview";
import EditMegaScholarship from "./pages/Admin/EditMegaScholarship";
//import PracticeSetPreview from "./pages/Admin/PracticeSetPreview";
import PracticeQuizPreview from "./pages/Admin/PracticeQuizPreview";
import AdminUsers from "./pages/Admin/AdminUsers";
import UserProfile from "./pages/UserProfile";
import UserView from "./pages/UserView";
import AboutUs from "./pages/Legal/AboutUs";
import PrivacyPolicy from "./pages/Legal/PrivacyPolicy";
import TermsConditions from "./pages/Legal/TermsConditions";
import ContactUs from "./pages/Legal/ContactUs";
import Pricing from "./pages/Legal/Pricing";
import ExamRules from "./pages/Legal/ExamRules";
import StudentStudy from "./pages/Student/Study";
import ResultHub from "./pages/Student/ResultHub";
import PracticeResult from "./pages/Student/PracticeResult";
//import NewPracticeResult from "./pages/Student/NewPracticeResult";
import ScholarshipList from "./pages/Student/ScholarshipList";
import PracticeHistory from "./pages/Student/PracticeHistory";
import StudentStudyContent from "./pages/Student/StudentStudyContent";
import StudentExamResult from "./pages/Student/StudentExamResult"
import ScholarshipAttempt from "./pages/Student/ScholarshipAttempt";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import MegaScholarshipResultList from "./pages/Student/MegaScholarshipResultList";
import ScholarshipResultList from "./pages/Student/ScholarshipResultList";
//import ScholarshipResult from "./pages/Student/ScholarshipResult";
//import MegaScholarshipResult from "./pages/Student/MegaScholarshipResult";
import MegaScholarshipLeaderboard from "./pages/Student/MegaScholarshipLeaderboard";
import MegaScholarshipParticipants from "./pages/Admin/MegaScholarshipParticipants";
import SupportCreate from "./pages/Student/SupportCreate";
import AdminSupportTickets from "./pages/Admin/SupportTickets";
import AdminSupportView from "./pages/Admin/SupportView";
import SupportTickets from "./pages/Admin/SupportTickets";
import SupportTicketView from "./pages/Admin/SupportTicketView";
import MySupportTickets from "./pages/Student/MySupportTickets";
import StudentSupportView from "./pages/Student/SupportTicketView";
import Notifications from "./pages/Student/Notifications";
import CreateCaseStudyPractice from "./pages/Admin/CaseStudyPractice/CreateCaseStudyPractice";
import AssignCaseStudies from "./pages/Admin/CaseStudyPractice/AssignCaseStudies";
import CaseStudyPracticeList from "./pages/Admin/CaseStudyPractice/CaseStudyPracticeList";
import ViewCaseStudyPractice from "./pages/Admin/CaseStudyPractice/ViewCaseStudyPractice";
import EditCaseStudyPractice from "./pages/Admin/CaseStudyPractice/EditCaseStudyPractice";
import StudentCaseStudyPractice from "./pages/Student/StudentCaseStudyPractice";
import CaseStudyPracticeTake from "./pages/Student/CaseStudyPracticeTake";
import CaseStudyPracticeResult from "./pages/Student/CaseStudyPracticeResult";
import AdminReasoningQuestions from "./pages/Admin/AdminReasoningQuestions";
import AssignReasoningToPractice from "./pages/Admin/AssignReasoningToPractice";
import AssignReasoningToMega from "./pages/Admin/AssignReasoningToMega";
import ViewReasoningQuestion from "./pages/Admin/ViewReasoningQuestion";
import EditReasoningQuestion from "./pages/Admin/EditReasoningQuestion";
import AdminReasoningList from "./pages/Admin/AdminReasoningList";
import AppPreview from "./pages/Legal/AppPreview";



// ProtectedRoute component
function ProtectedRoute({ children, allowedRoles }) {
  let user = null;
  let token = localStorage.getItem("token");

  try {
    user = getCurrentUser();
  } catch {
    localStorage.removeItem("token");
    return <Navigate to="/login" replace />;
  }

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    alert("❌ Access Denied!");
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default function App() {
  // 🔥 DEVICE ID INIT – RUNS ONCE
  useEffect(() => {
    initDeviceId().catch(err => {
      console.error("Device ID init failed:", err);
    });
  }, []);
  return (
    <Router>
      <Routes>

        {/* LOGIN */}
        <Route path="/login" element={<Login />} />

        {/* DASHBOARDS */}
        <Route path="/admin/dashboard" element={
          <ProtectedRoute allowedRoles={["super_admin"]}>
            <AdminDashboard />
          </ProtectedRoute>
        } />

        <Route path="/management/dashboard" element={
          <ProtectedRoute allowedRoles={["management","super_admin"]}>
            <ManagementDashboard />
          </ProtectedRoute>
        } />

        <Route path="/user/dashboard" element={
          <ProtectedRoute allowedRoles={["student","user","management","super_admin"]}>
            <UserDashboard />
          </ProtectedRoute>
        } />

        {/* MANAGE MODULES */}
        <Route path="/admin/subjects" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><Subjects /></ProtectedRoute>} />

        <Route path="/admin/questions" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><Questions /></ProtectedRoute>} />

        {/* VIEW + EDIT QUESTION ROUTES */}
        <Route path="/admin/view-questions" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><ViewQuestions /></ProtectedRoute>} />

        {/* 🚀 FIXED — CORRECT PARAM ROUTE */}
        <Route
            path="/admin/question/edit/:id"
            element={
              <ProtectedRoute allowedRoles={["super_admin", "management"]}>
                <EditQuestion />
              </ProtectedRoute>
            }
          />

        {/* CASE STUDY */}
        <Route path="/admin/case-study-questions" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><ViewCaseStudy /></ProtectedRoute>} />
        <Route path="/admin/case-study/edit/:id" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><EditCaseStudy /></ProtectedRoute>} />

        {/* UPLOAD CSV */}
        <Route path="/admin/upload-csv" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><UploadCSV /></ProtectedRoute>} />

        {/* STUDY CONTENT */}
        <Route path="/admin/study-content-list" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><StudyContentList /></ProtectedRoute>} />
        <Route path="/admin/study-content-edit/:id" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><StudyContentEdit /></ProtectedRoute>} />

        {/* OTHER */}
        <Route path="/admin/practice-set" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><AdminPracticeSet /></ProtectedRoute>} />
        <Route path="/admin/scholarship" element={<ProtectedRoute allowedRoles={["super_admin","management"]}><AdminScholarshipExam /></ProtectedRoute>} />
        <Route path="/subscription" element={<ProtectedRoute allowedRoles={["user","student","management","super_admin"]}><Subscription /></ProtectedRoute>} />
        <Route
          path="/admin/case-study-practice"
          element={<CreateCaseStudyPractice />}
        />

        <Route
          path="/admin/case-study-practice/list"
          element={<CaseStudyPracticeList />}
        />

        <Route
          path="/admin/case-study-practice/:id/view"
          element={<ViewCaseStudyPractice />}
        />

        <Route
          path="/admin/case-study-practice/:id/edit"
          element={<EditCaseStudyPractice />}
        />

        <Route
          path="/student/case-study-practice/:id"
          element={<StudentCaseStudyPractice />}
        />

        <Route
          path="/student/case-study/take"
          element={<CaseStudyPracticeTake />}
        />

        <Route
          path="/student/case-study/result"
          element={<CaseStudyPracticeResult />}
        />

        {/* STUDENT */}
        <Route path="/admin/practice-set-list" element={<PracticeSetList />} />
        <Route path="/student/practice" element={<StudentPracticeList />} />
        {/*<Route path="/student/practice/take" element={<StudentTakePractice />} />*/}
        <Route path="/student/practice/take/:setId" element={<StudentTakePractice />} />

        <Route path="/my-subscription" element={<MySubscription />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />

        {/* Inside Routes */}
        <Route path="/admin/practice-set/:id" element={<ViewPracticeSet />} />
        <Route path="/admin/edit-practice-set/:id" element={<EditPracticeSet />} />
        <Route path="/admin/edit-mega-scholarship/:id" element={<EditMegaScholarship />} />
        <Route path="/admin/create-mega-scholarship" element={<CreateMegaScholarship />} />
        <Route path="/admin/mega-scholarship-list" element={<MegaScholarshipList />} />
        <Route path="/student/quiz/:id" element={<ProtectedRoute allowedRoles={["user","student","management","super_admin"]}><QuizPage /></ProtectedRoute>} />
        <Route path="/admin/mega-scholarship/:examId/preview" element={
            <ProtectedRoute allowedRoles={["super_admin","management"]}>
              <AdminMegaQuizPreview />
            </ProtectedRoute>
          } />
        <Route path="/admin/practice-set/:id/preview" element={<PracticeQuizPreview />} />
        <Route path="/student/practice-list" element={<UserPracticeList />} />
        <Route path="/student/quiz/:id" element={<QuizPage />} />
        <Route path="/admin/mega-scholarship/:examId/add-questions" element={<AddQuestionsToMegaExam />} />
        
        <Route path="/admin/mega-scholarship/:id" element={<ViewMegaScholarship />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/user/:id" element={<UserProfile />} />
        <Route path="/admin/users/view/:id" element={<UserView />} />
        
        {/* DEFAULT */}
        <Route path="*" element={<Navigate to="/login" replace />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/exam-rules" element={<ExamRules />} />
        <Route path="/app-preview" element={<AppPreview />} />
        <Route path="/student/study" element={<StudentStudy />} />
        <Route path="/student/practice/result" element={<PracticeResult />} />
        {/*<Route path="/student/practice/result" element={<NewPracticeResult />} />*/}
        <Route path="/student/results" element={<ResultHub />} />
        <Route path="/student/scholarship-list" element={<ScholarshipList />} />
        {/*<Route path="/student/results" element={<PracticeHistory />} />*/}
        {/*<Route path="/student/results/practice" element={<PracticeHistory />} />*/}
        {/*<Route path="/student/results/scholarship" element={<ScholarshipResult />} />*/}
        {/*<Route path="/student/results/mega" element={<MegaScholarshipResult />} />*/}
        <Route path="/student/content/:id" element={<ProtectedRoute allowedRoles={["user","student"]}><StudentStudyContent /></ProtectedRoute>} />
        {/*<Route path="/student/mega-scholarship/:id/result" element={<StudentExamResult />} />*/}
        
        <Route
          path="/admin/case-study-practice/:practiceSetId/assign"
          element={<AssignCaseStudies />}
        />


        <Route
          path="/student/mega-scholarship/:id"
          element={
            <ProtectedRoute allowedRoles={["user","student","management","super_admin"]}>
              <ScholarshipAttempt />
            </ProtectedRoute>
          }
        />

        <Route
          path="/student/mega-scholarship/:id/attempt"
          element={
            <ProtectedRoute allowedRoles={["user","student","management","super_admin"]}>
              <QuizPage />
            </ProtectedRoute>
          }
        />

        {/* RESULT HUB */}
        <Route
          path="/student/results"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <ResultHub />
            </ProtectedRoute>
          }
        />

        {/* PRACTICE RESULT LIST */}
        <Route
          path="/student/results/practice"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <PracticeHistory />
            </ProtectedRoute>
          }
        />

        {/* SCHOLARSHIP RESULT LIST */}
        <Route
          path="/student/results/scholarship"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <ScholarshipResultList />
            </ProtectedRoute>
          }
        />

        {/* MEGA SCHOLARSHIP RESULT LIST */}
        <Route
          path="/student/results/mega"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <MegaScholarshipResultList />
            </ProtectedRoute>
          }
        />

        {/* RESULT DETAIL – SINGLE PAGE */}
        <Route
          path="/student/result/:type/:id"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <StudentExamResult />
            </ProtectedRoute>
          }
        />

       <Route
          path="/student/mega/:id/leaderboard"
          element={<MegaScholarshipLeaderboard />}
        />

        <Route
          path="/admin/mega-scholarship/:id/participants"
          element={<MegaScholarshipParticipants />}
        />

        <Route
          path="/student/support"
          element={
            <ProtectedRoute allowedRoles={["student","user"]}>
              <SupportCreate />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/support"
          element={
            <ProtectedRoute allowedRoles={["super_admin","management"]}>
              <AdminSupportTickets />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/support/:id"
          element={
            <ProtectedRoute allowedRoles={["super_admin","management"]}>
              <AdminSupportView />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/support"
          element={
            <ProtectedRoute allowedRoles={["super_admin","management"]}>
              <SupportTickets />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/support/:id"
          element={
            <ProtectedRoute allowedRoles={["super_admin","management"]}>
              <SupportTicketView />
            </ProtectedRoute>
          }
        />

        <Route path="/student/support"
          element={<ProtectedRoute allowedRoles={["student","user"]}><MySupportTickets /></ProtectedRoute>}
        />

        <Route path="/student/support/:id"
          element={<ProtectedRoute allowedRoles={["student","user"]}><StudentSupportView /></ProtectedRoute>}
        />

        <Route
          path="/student/notifications"
          element={
            <ProtectedRoute allowedRoles={["student", "user"]}>
              <Notifications />
            </ProtectedRoute>
          }
        />
        {/* ================= REASONING (ADMIN) ================= */}

        <Route
          path="/admin/reasoning/assign/practice/:practiceSetId"
          element={
            <ProtectedRoute allowedRoles={["super_admin", "management"]}>
              <AssignReasoningToPractice />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/reasoning/assign/mega/:examId"
          element={
            <ProtectedRoute allowedRoles={["super_admin", "management"]}>
              <AssignReasoningToMega />
            </ProtectedRoute>
          }
        />
        <Route path="/admin/reasoning" element={<AdminReasoningQuestions />} />
        <Route path="/admin/reasoning/view/:id" element={<ViewReasoningQuestion />} />
        <Route path="/admin/reasoning/edit/:id" element={<EditReasoningQuestion />} />
        <Route path="/admin/reasoning/list" element={<AdminReasoningList />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}